<p-dialog header="Error" [(visible)]="errorMessage" [draggable]="false" [modal]="true">
  <p class="text-danger">{{errorMessage}}</p>
  <ng-template pTemplate="footer">
      <button type="button" pButton pRipple class="p-button p-button-outlined" label="Ok" icon="pi pi-check" (click)="errorMessage=''"></button>
  </ng-template>
</p-dialog>

<form #form="ngForm">
  <!-- Row 1 -->
  <p-fieldset legend="Manual Config">
    <div class="p-fluid p-grid">
      
      <!-- Roster Code -->
      <div class="p-field p-col-12 p-md-3 p-mb-0">
        <span class="p-float-label">
          <p-dropdown [options]="rosterCodes" 
                      inputid="rosterCode"
                      name="rosterCode"
                      class="p-inputtext-sm" 
                      appendTo="body"
                      showClear="true"
                      optionLabel="code"
                      dataKey="id"
                      [autoDisplayFirst]="false"
                      (onChange)="onRosterCodeChanged($event)"
                      [(ngModel)]="selectedRosterValue.rc">
          
            <ng-template let-rosterCode pTemplate="item">
              <div>
                <span style="display:inline-block;width:40px;">{{rosterCode.code}}</span>
              </div>
            </ng-template>                    
          </p-dropdown>
          <label for="rosterCode">Roster Code</label>
        </span>
      </div>

      <!-- Payroll Roster Code -->
      <div class="p-field p-col-12 p-md-4 p-mb-0" *ngIf="showPayrollRosterCode()">
        <span class="p-float-label">
          <p-dropdown [options]="payrollRosterCodes" 
                      inputid="payrollRosterCode"
                      name="payrollRosterCode"
                      class="p-inputtext-sm" 
                      appendTo="body"
                      showClear="true"
                      optionLabel="code"
                      dataKey="id"
                      [autoDisplayFirst]="false"
                      [(ngModel)]="selectedRosterValue.prc">
          
            <ng-template let-rosterCode pTemplate="item">
              <div>
                <span style="display:inline-block;width:40px;">{{rosterCode.code}}</span>
              </div>
            </ng-template>                    
          </p-dropdown>
          <label for="payrollRosterCode">Payroll Roster Code</label>
        </span>
      </div>

      <div class="p-field p-col-12 p-md-3 p-mb-0" *ngIf="showDayNo">
        <span class="p-float-label">
          <p-inputNumber  name="SequenceNumber"
                          id="SequenceNumber" 
                          class="p-inputtext-sm"
                          mode="decimal" 
                          [minFractionDigits]="0"
                          [(ngModel)]="selectedRosterValue.sn"></p-inputNumber>
          <label for="SequenceNumber">Days #</label>
        </span>
      </div>

      <div class="p-field p-col-12 p-md-3 p-mb-0" *ngIf="showTicketStatus()">
        <span class="p-float-label">
          <p-dropdown [options]="ticketStatuses" 
                      inputid="ticketStatus"
                      name="ticketStatus"
                      class="p-inputtext-sm" 
                      appendTo="body"
                      showClear="true"
                      optionLabel="name"
                      optionValue="id"
                      [autoDisplayFirst]="false"
                      [(ngModel)]="selectedRosterValue.ts.id"></p-dropdown>
          <label for="ticketStatus">Travel status</label>
        </span>
      </div>
    </div>

    <!-- Row 1 -->
    <div class="p-fluid p-formgrid-del p-grid p-mt-2">
      <!--From Date-->
      <div class="p-field p-col-12 p-md-6 p-mb-0">
        <span class="p-float-label">
          <p-calendar class="p-inputtext-sm" 
                      appendTo="body"
                      showIcon="true" 
                      dateFormat="dd/mm/yy"
                      inputId="fromDate"
                      name="fromDate"
                      [(ngModel)]="fromDate"
                      ></p-calendar>
          <label for="fromDate">From</label>
        </span>
      </div>
      <!--To Date-->
      <div class="p-field p-col-12 p-md-6 p-mb-0">
        <span class="p-float-label">
          <p-calendar class="p-inputtext-sm" 
                      appendTo="body"
                      showIcon="true" 
                      dateFormat="dd/mm/yy"
                      inputId="toDate"
                      name="toDate"
                      [(ngModel)]="toDate"
                      ></p-calendar>
          <label for="toDate">To</label>
        </span>
      </div>
    </div>
  </p-fieldset>

  <!-- Temporary disabled the update by rule feature since it is not required by business 02/17/2022 -->
  <!--
  <p-fieldset legend="Batch Config">
    <div class="p-fluid p-formgrid-del p-grid p-mt-0">
      
      <div class="p-field p-col-12 p-md-7 p-mb-0">
        <span class="p-float-label">
          <input pInputText 
                id="rosterPattern" name="rosterPattern"
                class="p-inputtext-sm"
                [(ngModel)]="rosterPattern" />
          <label for="rosterPattern">Rule</label>
        </span>
      </div>
      
      <div class="p-field p-col-12 p-md-3 p-mb-0">
        <span class="p-float-label">
          <p-inputNumber  name="cycles"
                          id="cycles" 
                          class="p-inputtext-sm"
                          mode="decimal" 
                          [minFractionDigits]="0"
                          [(ngModel)]="cycles"></p-inputNumber>
          <label for="cycles">Cycles</label>
        </span>
      </div>

      <div class="p-field p-col-12 p-md-2 p-text-right p-mb-0">
        <button pButton pRipple label="Apply" 
                class="p-button-sm p-button-raised p-button-success" type="button" 
                icon="pi pi-check"
                (click)="save(form, 1);"></button>
      </div>
    </div> 
  </p-fieldset>
  -->

  <p-fieldset legend="Roster Note" *ngIf="showRosterNoteField">
    <div class="p-fluid p-formgrid-del p-grid">
      <!--Roster Note-->
      <div class="p-field p-col-12 p-md-12 p-mb-0">
        <textarea pInputTextarea class="p-inputtext-sm"
          id="rosterNote"
          name="rosterNote" 
          rows="8"
          [(ngModel)]="selectedRosterValue.rn.note"></textarea>
      </div>
    </div> 
  </p-fieldset>

  <div class="modal-footer">
    <button pButton pRipple label="Save" 
            class="p-button p-button-raised p-button-success" type="button" 
            icon="fas fa-check"
            (click)="save(form, 2);"></button>
    <button type="button" pButton pRipple class="p-button p-button-outlined" label="Cancel" icon="pi pi-times" (click)="cancel()"></button>
  </div>
</form>

<p-confirmDialog key="invalidPayrollRosterCodePromptDialog"></p-confirmDialog>
  